import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const container = css`
  padding: 2rem;
  @media (max-width: ${dimensions.phoneLargeMax}) {
    overflow-y: visible;
  }
`;
